import React, { useState, useContext } from 'react'
import {
  Divider,
  Container,
  Grid,
  Radio,
  FormControlLabel,
  RadioGroup,
} from '@material-ui/core'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import Cards from 'react-credit-cards'
import 'react-credit-cards/es/styles-compiled.css'
import './CreditCard.scss'
import FlexView from 'react-flexview/lib'
import { SessionContextStore } from '../../context/SessionContext'
import {
  EventEmitterService,
  EventKey,
} from '../../services/EventEmitterService'
import { awaitWithLoading, isInFlow } from '../../services/utils'
import { UserApi } from '../../api/user.api'
import { BrowserView, isBrowser, MobileView } from 'react-device-detect'
import { TextDivider } from '../Core/TextDivier'
import { useLocation } from 'react-router-dom'
import { ContinueButton } from '../Core/Buttons/ContinueButton'
import { BackButton } from '../Core/Buttons/BackButton'
import { GreenButton } from '../Core/Buttons/GreenButton'
import { CreditCardLogo } from '../Core/CreditCardLogo'
import { BottomSheetPolicySummary } from '../Insurance/BottomSheetPolicySummary'
import NewFillButton from '../Core/NewFillButton'
import DataLayerService from '../../services/DataLayerService'
import { Experiment, Variant } from 'react-optimize'
import {
  InsurancePurchaseContextStore,
  INSURANCE_CONTEXT_ACTIONS,
} from '../../context/InsuracePurchaseContext'
import { PaymentMethod } from '../../models/user-models/CreditCardModal'
import { Action } from '../../models/Action'
import { SessionService } from '../../services/SessionService'
import insuranceApi from '../../api/insurance.api'
import { BuyingInsuranceContextStore } from '../../context/BuyingInsuranceContext'
import { SkyPaper } from '../Core/Frames/SkyPaper'
import { BlueGrayBox } from '../Core/BlueGrayBox'
import { ReactComponent as CCSvg } from '../../assets/cc.svg'
import { TermsAndConditionsSection } from '../Insurance/SummarySection/TermsAndConditionsSection'
import PaymentMethods from './PaymentMethods'

var classNames = require('classnames')

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY)

export const CheckoutForm = () => {
  const insuranceContext = useContext(InsurancePurchaseContextStore)
  const offersContext = useContext(BuyingInsuranceContextStore)
  const location = useLocation()

  const onPurchase = async () => {
    if (!isInFlow(location.pathname)) return

    console.log('xxx', offersContext.offerId)
    if (offersContext.offerId) {
      let res = await awaitWithLoading(offersContext.purchaseOffer())
      if (res.ok) {
        // EventEmitterService.dispatch(EventKey.FLOW_INSURANCE_PURCHASED_SUCCESS, res.data)
        EventEmitterService.dispatch(
          EventKey.FLOW_INSURANCE_PURCHASED_SUCCESS,
          res.data
        )
      } else {
        EventEmitterService.dispatch(EventKey.ShowError, res)
      }
    }
  }

  return (
    <React.Fragment>
      <MobileView>
        <div className="margin-top-medium">
          <TextDivider>
            <div className="text-title bold blue">Payment details</div>
          </TextDivider>
        </div>
      </MobileView>
      <Container className="margin-top-medium">
        <BrowserView>
          <FlexView vAlignContent={'center'} className="space-between">
            <FlexView vAlignContent={'center'}>
              <CCSvg className="margin-right-6 medium-icon" />
              <div className="blue text-title bold">Payment Details</div>
            </FlexView>
            <img
              className="strip-powered"
              src={`${process.env.PUBLIC_URL}/assets/stripe.png`}
            />
          </FlexView>
          <Divider />
        </BrowserView>
        <MobileView>
          <FlexView className="space-between">
            <div className="black text-title margin-bottom-basic">
              Add credit card
            </div>
            <img
              className="strip-powered"
              src={`${process.env.PUBLIC_URL}/assets/stripe.png`}
            />
          </FlexView>
        </MobileView>
        <Elements stripe={stripePromise}>
          <PaymentMethods onPurchase={onPurchase} />
        </Elements>
      </Container>
    </React.Fragment>
  )
}
